<div class="relative">
  <div class="absolute inset-y-0 left-0 z-10 flex items-center">
    <select id="prefix" name="currency" [formControl]="prefix"
            class="h-full border-transparent bg-grayLight py-0 pr-2 pl-7 text-black sm:text-sm">
      <option *ngFor="let value of prefixes" [value]="value">{{ value }}</option>
    </select>
  </div>
  <input type="text"
         [mask]="mask"
         [formControl]="number"
         [attr.aria-label]="label"
         style="padding-left: 3.5rem !important;"
         [ngClass]="{ 'input-error': control.invalid }"
         [placeholder]="placeholder"
         [maxLength]="maxLength"
         [minLength]="minLength"
         i18n-placeholder
         autocomplete="off"/>
  <span class="absolute right-0 mr-8 ml- z-20 pointer-events-none text-xs text-grayDark" style="margin-top: 0.85rem;"
        *ngIf="append">{{ append }}</span>
</div>
<app-field-errors [control]="control"></app-field-errors>
